import { render, staticRenderFns } from "./recordMerge.vue?vue&type=template&id=5d5d4d1e"
import script from "./recordMerge.vue?vue&type=script&lang=js"
export * from "./recordMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports